(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function() {
    // 使用事件委托，在 document 上监听点击事件
    // 这样即使 DOM 更新，事件监听器仍然有效
    document.addEventListener('click', function(event) {
      // 首先排除 facet-floating-filter 及其内部元素的点击
      const facetFloatingFilter = event.target.closest('facet-floating-filter');
      if (facetFloatingFilter) return;

      // 检查点击的是否是 .yg-sort_by 或其子元素
      const ygSortBy = event.target.closest('.yg-sort_by');
      if (!ygSortBy) return;

      const facetsDrawer = document.getElementById('facets-drawer');
      if (!facetsDrawer || typeof facetsDrawer.show !== 'function') return;

      // 打开抽屉
      facetsDrawer.show().then(function() {
        // 等待抽屉打开后，检查并触发 accordion toggle
        setTimeout(function() {
          const accordion = document.querySelector('#facet-form #accordion-sort-by');
          const toggle = accordion?.querySelector('.accordion__toggle');
          
          if (accordion && toggle) {
            // 如果 accordion 已经打开，就不需要再触发 toggle
            if (accordion.open) {
              return;
            }
            
            // 如果 accordion 还没打开，则打开它并触发 toggle
            accordion.setAttribute('open', '');
            accordion.setAttribute('aria-expanded', 'true');
            // 触发点击事件来确保所有相关事件都被触发
            toggle.click();
          }
        }, 100);
      });
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-all-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class YGAllProductsBox extends YGUtils {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init() {
        const toggleButton = this.querySelector('.yg-toggle-button');
        const productBoxes = this.querySelectorAll('.yg-product-box');
        const moreText = this.querySelector('.yg-toggle-more-text');
        const lessText = this.querySelector('.yg-toggle-less-text');

        if (toggleButton) {
          toggleButton.addEventListener('click', () => {
            const isExpanded = toggleButton.classList.contains('expanded');

            // 切换所有 product-box 的 hide 类
            productBoxes.forEach(box => {
              if (isExpanded) {
                // 收起：前3个之外的需要隐藏
                const index = Array.from(productBoxes).indexOf(box);
                if (index >= 3) {
                  box.classList.add('hide');
                }
              } else {
                // 展开：移除 hide 类
                box.classList.remove('hide');
              }
            });

            // 切换文字内容
            if (isExpanded) {
              moreText.classList.remove('hide');
              lessText.classList.add('hide');
            } else {
              moreText.classList.add('hide');
              lessText.classList.remove('hide');
            }

            toggleButton.classList.toggle('expanded');
          });
        }
      }
    }

    if (!window.customElements.get('yg-all-products-box')) {
      window.customElements.define('yg-all-products-box', YGAllProductsBox);
    }

    class YGProductBoxSwiper extends YGUtils {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init() {

        const nextButton = this.querySelector('.swiper-button-next');
        const prevButton = this.querySelector('.swiper-button-prev');
        const pagination = this.querySelector('.swiper-pagination');

        this.swiper = new Swiper(this, {
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          pagination: pagination ? {
            el: pagination,
            type: "progressbar",
          } : false,
          breakpoints: {
            260: {
              slidesPerView: 2,
              spaceBetween: 6,
            },
            700: {
              slidesPerView: 3,
              spaceBetween: 12,
            },
            1000:{
              slidesPerView: 5,
              spaceBetween: 12,
            }
          },
        });
      }
    }

    if (!window.customElements.get('yg-product-box-swiper')) {
      window.customElements.define('yg-product-box-swiper', YGProductBoxSwiper);
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-blog-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class YGBlogPostsSwiper extends YGUtils {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init() {

        const nextButton = this.querySelector('.swiper-button-next');
        const prevButton = this.querySelector('.swiper-button-prev');
        const pagination = this.querySelector('.swiper-pagination');

        this.swiper = new Swiper(this, {
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          pagination: pagination ? {
            el: pagination,
            type: "progressbar",
          } : false,
          breakpoints: {
            260: {
              slidesPerView: 1,
              spaceBetween: 6,
            },
            700: {
              slidesPerView: 3,
              spaceBetween: 12,
            },
          },
        });
      }
    }

    if (!window.customElements.get('yg-blog-posts-swiper')) {
      window.customElements.define('yg-blog-posts-swiper', YGBlogPostsSwiper);
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-influencer-swiper"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {

    class YGInfluencerSwiper extends YGUtils {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init() {

        const nextButton = this.querySelector('.swiper-button-next');
        const prevButton = this.querySelector('.swiper-button-prev');
        const pagination = this.querySelector('.swiper-pagination');

        this.swiper = new Swiper(this, {
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          pagination: pagination ? {
            el: pagination,
            type: "progressbar",
          } : false,
          breakpoints: {
            260: {
              slidesPerView: 1,
              spaceBetween: 6,
            },
            700: {
              slidesPerView: 3,
              spaceBetween: 12,
            },
            1000:{
              slidesPerView: 4,
              spaceBetween: 12,
            }
          },
        });
      }
    }

    if (!window.customElements.get('yg-influencer-swiper')) {
      window.customElements.define('yg-influencer-swiper', YGInfluencerSwiper);
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-switcher"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-card-swiper"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGProductCardSwiper extends YGUtils {
      constructor() {
        super();
        
        this.init();
      }

      init() {
        const columnsMobile = parseFloat(this.dataset.columnsMobile) || 2;
        const columnsDesktop = parseInt(this.dataset.columnsDesktop) || 4;

        new Swiper(this.querySelector('.swiper'), {
          spaceBetween: 6, //轮播中幻灯片之间的间距
          slidesPerView: columnsMobile,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            //设置响应式断点
            700: {
              slidesPerView: columnsDesktop, //当窗口宽度大于等于700px时，设置每屏显示的幻灯片数量为4
              spaceBetween: 12,
            },
          },
        });
      }
    }

    if (!window.customElements.get('yg-product-card-swiper')) {
      window.customElements.define('yg-product-card-swiper', YGProductCardSwiper);
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-autoplay"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {

    class YGVideoAutoplaySwiper extends YGUtils {
      constructor() {
        super();
        this.isMobile = window.innerWidth < 700;
      }

      connectedCallback() {
        this.init();
        this.bindEvents();
      }

      init() {
        const nextButton = this.querySelector('.swiper-button-next');
        const prevButton = this.querySelector('.swiper-button-prev');

        this.swiper = new Swiper(this, {
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          breakpoints: {
            260: {
              slidesPerView: 1.2,
              spaceBetween: 6,
            },
            700: {
              slidesPerView: 3,
              spaceBetween: 12,
            },
            1000: {
              slidesPerView: 5,
              spaceBetween: 12,
            }
          },
          on: {
            init: () => this.handleSlideChange(),
            slideChange: () => this.handleSlideChange()
          }
        });
      }

      bindEvents() {
        // 移动端初始化时调用一次处理
        if (this.isMobile) {
          setTimeout(() => this.handleSlideChange(), 200);
        }

        // 绑定PC端鼠标悬停事件
        if (!this.isMobile) {
          this.querySelectorAll('.yg-video-autoplay-item').forEach(item => {
            item.addEventListener('mouseenter', () => {
              const videoElement = item.querySelector('yg-video');
              if (videoElement && typeof videoElement.playVideo === 'function') {
                videoElement.playVideo();
              }
            });

            item.addEventListener('mouseleave', () => {
              const videoElement = item.querySelector('yg-video');
              if (videoElement && typeof videoElement.pauseVideo === 'function') {
                videoElement.pauseVideo();
              }
            });
          });
        }

        // 监听窗口大小变化，处理PC端和移动端切换
        window.addEventListener('resize', () => {
          const wasMobile = this.isMobile;
          this.isMobile = window.innerWidth < 700;

          if (wasMobile !== this.isMobile) {
            if (this.isMobile) {
              // 切换到移动端：移除PC端事件，初始化移动端
              this.unbindPCHoverEvents();
              this.handleSlideChange();
            } else {
              // 切换到PC端：重新绑定PC端事件，暂停所有移动端视频
              this.bindPCHoverEvents();
              this.pauseAllVideos();
            }
          }
        });
      }

      // 绑定PC端鼠标悬停事件
      bindPCHoverEvents() {
        this.querySelectorAll('.yg-video-autoplay-item').forEach(item => {
          item.addEventListener('mouseenter', () => {
            const videoElement = item.querySelector('yg-video');
            if (videoElement && typeof videoElement.playVideo === 'function') {
              videoElement.playVideo();
            }
          });

          item.addEventListener('mouseleave', () => {
            const videoElement = item.querySelector('yg-video');
            if (videoElement && typeof videoElement.pauseVideo === 'function') {
              videoElement.pauseVideo();
            }
          });
        });
      }

      // 移除PC端鼠标悬停事件
      unbindPCHoverEvents() {
        this.querySelectorAll('.yg-video-autoplay-item').forEach(item => {
          item.removeEventListener('mouseenter', () => {});
          item.removeEventListener('mouseleave', () => {});
        });
      }

      // 移动端处理：只有swiper-slide-active的视频播放
      handleSlideChange() {
        if (!this.isMobile) return;

        // 延迟执行，确保Swiper和DOM已完全准备好
        setTimeout(() => {
          if (!this.swiper || !this.swiper.slides) return;

          this.swiper.slides.forEach(slide => {
            const videoElement = slide.querySelector('yg-video');
            if (!videoElement) return;

            if (slide.classList.contains('swiper-slide-active')) {
              if (typeof videoElement.playVideo === 'function') {
                videoElement.playVideo();
              }
            } else {
              if (typeof videoElement.pauseVideo === 'function') {
                videoElement.pauseVideo();
              }
            }
          });
        }, 100);
      }

      // 暂停所有视频
      pauseAllVideos() {
        this.querySelectorAll('yg-video').forEach(video => {
          if (typeof video.pauseVideo === 'function') {
            video.pauseVideo();
          }
        });
      }
    }

    if (!window.customElements.get('yg-video-autoplay-swiper')) {
      window.customElements.define('yg-video-autoplay-swiper', YGVideoAutoplaySwiper);
    }
  })

  } catch(e) { console.error(e); }
})();
})();
